import { Injectable } from '@angular/core';
import { PaperSizeEnums } from 'src/app/enum/paper-size-enums';

@Injectable({
  providedIn: 'root'
})
export class PrintPageSizeService {

  constructor() { }

  setPageSizeStyle(paperSizeId: number) {
    const styleId = 'print-page-size-style';
    let styleEl = document.getElementById(styleId);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = styleId;
      document.body.appendChild(styleEl);
    }

    let size = 'letter';
    if (paperSizeId === PaperSizeEnums.halfLetter) {
      size = '8.5in 5.5in';
    }

    styleEl.innerHTML = `
      @page {
        size: ${size};
        margin: 3mm 1mm !important;
      }
    `;
  }

  removePageSizeStyle() {
    const styleEl = document.getElementById('print-page-size-style');
    if (styleEl) {
      styleEl.remove();
    }
  }
}
